export const MOBILE_SIZE = 430;

export const DATETIME_FORMAT = "YYYY-MM-DD hh:mm:ss A";
export const DATETIME_FORMAT_WITHOUT_SECOND = "YYYY-MM-DD hh:mm A";
export const DATETIME_WITHOUT_SECOND_FORMAT = "YYYY-MM-DDTHH:mm";
